// @typescript-eslint/no-explicit-any
import { normalizeProps } from "@zag-js/svelte";
const createApi = (initial) => {
    let api = $state(initial);
    return {
        ...initial,
        get api() {
            return api;
        },
        set api(value) {
            api = value;
        }
    };
};
export const useConnect = (service, connect) => {
    const reactiveApi = createApi(connect(service, normalizeProps));
    $effect(() => {
        reactiveApi.api = connect(service, normalizeProps);
    });
    return reactiveApi;
};
